import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-foreground-300">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-line text-white text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-white">
                51吃瓜官网
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-foreground-400">
              最新娱乐八卦爆料平台，51吃瓜爆料第一站。为你提供最快速、最真实的明星黑料和社会热点资讯。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">首页</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">关于我们</Link>
              <Link to="/category/mingxing-bagua" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">明星八卦</Link>
              <Link to="/category/shehui-redian" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">社会热点</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">关注我们</h4>
            <p className="text-sm text-foreground-400 mb-4">
              商务合作 / 投稿爆料：contact@51chigua.com
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors" rel="nofollow">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors" rel="nofollow">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors" rel="nofollow">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors" rel="nofollow">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-500">
            &copy; 2026 51吃瓜官网. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-foreground-500 hover:text-foreground-300 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-sm text-foreground-500 hover:text-foreground-300 transition-colors" rel="nofollow">免责声明</a>
            <a href="#" className="text-sm text-foreground-500 hover:text-foreground-300 transition-colors" rel="nofollow">用户协议</a>
          </div>
        </div>
      </div>
    </footer>
  );
}